import * as XLSX from "xlsx";

/**
 * Export rows to an .xlsx file.
 * @param {Object[]} rows - Array of objects (each row). Keys become column headers.
 * @param {string} filename - File name without extension (date suffix added by caller).
 * @param {string} [sheetName]
 */
export function exportXlsx(rows, filename, sheetName = "Datos") {
  const ws = XLSX.utils.json_to_sheet(rows || []);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
  const safe = filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`;
  XLSX.writeFile(wb, safe);
}

/**
 * Export using an AoA (array-of-arrays) when ordering matters or there are no row objects.
 */
export function exportXlsxAoA(aoa, filename, sheetName = "Datos") {
  const ws = XLSX.utils.aoa_to_sheet(aoa || []);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
  const safe = filename.endsWith(".xlsx") ? filename : `${filename}.xlsx`;
  XLSX.writeFile(wb, safe);
}
